import { Accordion, AccordionSummary, AccordionDetails, Button, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import MenuDeliveryCard from './MenuDeliveryCard';

const MenuWeekSection = ({ week, weekIdx, onChange, products, deliveryStartIndex = 0, deliveryDays = [], cycleStartDate, totalWeeks, menuId, menuStatus, onRegenerateOrder }) => {
  const handleDeliveryChange = (deliveryIdx, updatedDelivery) => {
    const newDeliveries = [...week.deliveries];
    newDeliveries[deliveryIdx] = updatedDelivery;
    onChange({ ...week, deliveries: newDeliveries });
  };

  const handleAddDelivery = () => {
    const dayIdx = week.deliveries.length;
    const defaultDay = deliveryDays.length > 0 ? deliveryDays[dayIdx % deliveryDays.length] : '';
    const newDelivery = {
      delivery_number: 0,
      delivery_day: defaultDay,
      label: '',
      total_weight: 0,
      sort_order: week.deliveries.length,
      items: [],
    };
    onChange({ ...week, deliveries: [...week.deliveries, newDelivery] });
  };

  const handleRemoveDelivery = (deliveryIdx) => {
    if (week.deliveries[deliveryIdx]?.has_orders) return;
    onChange({ ...week, deliveries: week.deliveries.filter((_, i) => i !== deliveryIdx) });
  };

  // Calculate week total converted weight
  const weekTotal = week.deliveries.reduce((sum, d) => {
    const deliveryTotal = d.items.reduce((s, item) => {
      if (item.item_type === 'FREE_GIFT') return s;
      if (item.quantity && item.convert_rate) return s + (item.quantity / item.convert_rate);
      if (item.weight_value) return s + parseFloat(item.weight_value);
      return s;
    }, 0);
    return sum + deliveryTotal;
  }, 0);

  return (
    <Accordion defaultExpanded={weekIdx === 0} sx={{ mb: 1 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontWeight: 600 }}>
          {week.label || `Tuần ${week.week_number}`}
          <Typography component="span" sx={{ ml: 2, color: 'text.secondary', fontSize: '0.875rem' }}>
            ({Math.round(weekTotal * 100) / 100} kg)
          </Typography>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {week.deliveries.map((delivery, idx) => (
          <MenuDeliveryCard
            key={idx}
            delivery={delivery}
            deliveryIndex={deliveryStartIndex + idx + 1}
            onChange={(updated) => handleDeliveryChange(idx, updated)}
            onRemove={() => handleRemoveDelivery(idx)}
            products={products}
            cycleStartDate={cycleStartDate}
            weekIdx={weekIdx}
            totalWeeks={totalWeeks}
            menuId={menuId}
            menuStatus={menuStatus}
            onRegenerateOrder={onRegenerateOrder}
          />
        ))}
        <Button startIcon={<AddIcon />} size="small" onClick={handleAddDelivery}>
          Thêm lần giao
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};

export default MenuWeekSection;
